export const downloadSuccess = "Zip file downloaded";
export const downloadFailed = "Downloading zip file failed.";
export const deleteSuccess = "Configuration deleted";
export const deleteFailed = "Configuration delete failed";
export const configurationDoesntExist = (id: number) =>
  `Configuration with id ${id} does not exist.`;
export const noConfigurationsAvailable = "There are no mobile configurations available";
export const noConfigurationsForQuery = (query: string) =>
  `No mobile configurations found for query '${query}'`;
export const defaultFilename = "config.zip";

export enum SortStrategy {
  NONE = "none",
  ID = "id",
  NAME = "name",
  DATE = "date"
}

export enum SortDirection {
  ASCENDING = "ascending",
  DESCENDING = "descending",
  NONE = "none"
}
